import api from "./api";

export const getAutonomousDecisionData = async () => {
    const [
        shipmentsRes,
        blockchainRes,
        iotRes,
        logsRes
    ] = await Promise.allSettled([
        api.get("/Shipment/all"),
        api.get("/BlockchainLog"),
        api.get("/IoTDevice"),
        api.get("/SystemLog")
    ]);

    const shipments =
        shipmentsRes.status === "fulfilled"
            ? shipmentsRes.value.data ?? []
            : [];

    const blockchain =
        blockchainRes.status === "fulfilled"
            ? blockchainRes.value.data ?? []
            : [];

    const devices =
        iotRes.status === "fulfilled"
            ? iotRes.value.data ?? []
            : [];

    const logs =
        logsRes.status === "fulfilled"
            ? logsRes.value.data ?? []
            : [];

    return {
        shipments,
        blockchain,
        devices,
        logs,

        trustScore: 94,
        aiRisk: 5,
        etaAccuracy: 96,

        recommendation:
            "Current logistics network is operating normally.",

        action:
            "No automatic intervention required.",

        confidence: 98
    };
};

export default {
    getAutonomousDecisionData
};